module.exports = __webpack_public_path__ + "media/images/frontend/pages/aboutus-1-ead89b70f0f446ef5b372ee0c9d8b31f.jpg";